import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  width: 100%;
`;

const StyledTextSection = styled.div`
  position: relative;
  color: #22272D;
  background-color: #FCFDFE; 
  padding-left: 10px;
  padding-right: 10px;
  
  a:link, a:visited {
    color: #22272D;
    text-decoration: underline;
    height: auto;
  }
  
  @media (max-width: 1023px) {
  }
  @media (max-width: 600px) {
  } 
  @media (max-width: 480px) {
  }
`;

const TextSection = (props) => (
  <StyledContainer>
    <StyledTextSection>{props.children}</StyledTextSection>
  </StyledContainer>);

export default TextSection;


// WEBPACK FOOTER //
// ./src/Components/TextSection.js